import { api } from './api';
import { CURRENCY_BASE } from '@/api/paths';
import { serverNow } from './clock-skew';

/**
 * PAZARYERI UCLARI ICIN ORTAK ZARF ISLEME.
 *
 * Sozlesme her ucta ayni: `{ code: 'success' | 'error', message, … }` ve
 * HTTP 200 + `code: 'error'` MUMKUN. Yalniz HTTP durumuna bakan bir cagri
 * basarisiz bir istegi basarili sanir; bu yuzden `code` HER ZAMAN kontrol
 * edilir ve tek yerde edilir.
 *
 * Dosya adi `task-` onekli: bu klasordeki paylasilan yardimcilar icin uzerinde
 * anlasilmis dosya sahipligi kurali (bkz. src/lib/task-*.ts).
 */

export type ApiEnvelope = { code?: string; message?: string };

/** Sunucunun `code: 'error'` yanitini tasiyan hata. */
export class ApiError extends Error {
  readonly code: string;

  constructor(code: string, message?: string) {
    super(message ?? code);
    this.name = 'ApiError';
    this.code = code;
  }
}

/**
 * Beklenmeyen YANIT SEKLI. Sessizce bos listeye dusmek yerine firlatilir:
 * "kayit yok" ile "yaniti anlayamadim" ayni ekrani gostermemeli — birincisi
 * normal, ikincisi bir hata ve tekrar denenebilir olmali.
 */
export class ApiShapeError extends Error {
  constructor(detail: string) {
    super(`Beklenmeyen yanit sekli: ${detail}`);
    this.name = 'ApiShapeError';
  }
}

/** Sayfalanmis bir yanittan `items` dizisini SEKLINI DOGRULAYARAK cikarir. */
export const expectItems = (
  data: { items?: unknown },
  endpoint: string,
): Record<string, unknown>[] => {
  const { items } = data;
  if (!Array.isArray(items)) throw new ApiShapeError(`${endpoint}.items dizi degil`);
  return items.filter((item): item is Record<string, unknown> => typeof item === 'object' && item !== null);
};

/** `code` 'success' degilse ApiError firlatir; degilse govdeyi gecirir. */
export const unwrap = <T extends ApiEnvelope>(data: T): T => {
  if (data.code !== 'success') {
    throw new ApiError(data.code ?? 'UNKNOWN_ERROR', data.message);
  }
  return data;
};

/** Currency servisine GET. Yanit zarfi dogrulanir, alinma ani damgalanir. */
export const currencyGet = async <T extends ApiEnvelope>(
  path: string,
  params?: Record<string, string | number | undefined>,
): Promise<{ data: T; receivedAtMs: number }> => {
  const response = await api.get<T>(`${CURRENCY_BASE}${path}`, params ? { params } : undefined);
  // serverNow() BURADA okunur: yanit kesicisi `Date` basligini az once isledi,
  // yani sapma olcumu bu yanit kadar taze. Geri sayimlar bu ani referans alir.
  return { data: unwrap(response.data), receivedAtMs: serverNow() };
};

/** Currency servisine POST. */
export const currencyPost = async <T extends ApiEnvelope>(
  path: string,
  body: Record<string, unknown>,
): Promise<T> => {
  const response = await api.post<T>(`${CURRENCY_BASE}${path}`, body);
  return unwrap(response.data);
};
